import { render } from "./MlSwitcher.vue?vue&type=template&id=37ca5549&scoped=true"
import script from "./MlSwitcher.vue?vue&type=script&lang=js"
export * from "./MlSwitcher.vue?vue&type=script&lang=js"

import "./MlSwitcher.vue?vue&type=style&index=0&id=37ca5549&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ca5549"]])

export default __exports__